export default __webpack_public_path__ + "images/107f351cb5116f85bfbaad55575f5794.svg";